import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta } from '../../web/ReactQueryProvider';
import { IManagedAccountSummary } from './types';

const BASE_QUERY_KEY = 'ManagedAccount';

export function useManagedAccountsQuery({
	enabled = true,
	meta,
}: {
	enabled?: boolean;
	meta?: LevStandardQueryMeta;
} = {}) {
	const userSession = useUserSession();

	return useQuery({
		queryKey: [BASE_QUERY_KEY],
		queryFn: () =>
			userSession.webServiceHelper.callAsync<IManagedAccountSummary[]>({
				path: 'ManagedAccount',
				method: 'GET',
			}),
		enabled,
		meta,
	});
}
